module.exports = __webpack_public_path__ + "img/logo-shiba888.41876723.png";